import { render, staticRenderFns } from "./VueAudio.vue?vue&type=template&id=0d4cbf54&scoped=true&"
import script from "./VueAudio.vue?vue&type=script&lang=js&"
export * from "./VueAudio.vue?vue&type=script&lang=js&"
import style0 from "./VueAudio.vue?vue&type=style&index=0&id=0d4cbf54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4cbf54",
  null
  
)

export default component.exports